import React, { Component } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME } from "../../constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
import "../../component/admin/MultipleReactQuillEditor";
import { MultipleReactQuillEditor } from "../../component/admin/MultipleReactQuillEditor";
import NewReachTextEditor from "./NewReachTextEditor";

const saveDoctor = (
  data,
  doctor_profile,
  // status_list,
  Schedule,
  selectedDepartmentId,
  descriptions,
  tableHTML
) => {
  let formdata = new FormData();

  formdata.append("doctor_profile", doctor_profile);
  // formdata.append("status_list", JSON.stringify(status_list));
  formdata.append("Schedule", JSON.stringify([Schedule]));
  formdata.append("selectedDepartmentId", selectedDepartmentId);
  formdata.append("description_list", JSON.stringify(descriptions));
  formdata.append("doctor_table", JSON.stringify(tableHTML));
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.post("/doctors/createdoctor", formdata, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": `multipart/form-data; boundary=${formdata._boundary}`,
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: data,
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getAllDepartments = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/department/getdepartments", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const alertStyle = {
  color: "red",
};
class adddoctor extends Component {
  state = {
    fields: {},
    errors: {},

    doctor_id: "",
    doctor_name: "",
    doctor_degree: "",
    doctor_designation: "",
    doctor_fees: "",
    doctor_department: "",
    doctor_uhl_id: "",
    doctor_bmdc_id: "",
    doctor_profile: "",
    editorLoaded: false,
    data: "",
    Schedule: {
      Saturday: "",
      Sunday: "",
      Monday: "",
      Tuesday: "",
      Wednesday: "",
      Thursday: "",
      Friday: "",
    },
    // status_list: [
    //   { field_name: "doctor_desc", visibility: 1 },
    //   { field_name: "doctor_edu", visibility: 1 },
    //   { field_name: "doctor_exp", visibility: 1 },
    //   { field_name: "doc_professional_skills", visibility: 1 },
    //   { field_name: "doc_memberships", visibility: 1 },
    //   { field_name: "doc_awards", visibility: 1 },
    //   { field_name: "doc_key_research_experience", visibility: 1 },
    //   { field_name: "doc_key_publications", visibility: 1 },
    //   { field_name: "doc_key_scientific_presentations", visibility: 1 },
    // ],
    descriptions: [
      { value: "", visibility: 1, key: this.generateRandomText() },
    ],
    departments: [],
    selectedDepartmentId: [], // Holds selected department IDs
    departmentSearch: "", // Search term for filtering departments

    tableRows: 1, // Default number of rows
    tableColumns: 1, // Default number of columns
    tableData: Array(1)
      .fill("")
      .map(() => Array(1).fill("")), // Initialize with empty cells
  };
  validateForm() {
    let errors = {};
    let formIsValid = true;
    if (!this.state.doctor_name) {
      formIsValid = false;
      errors["doctor_name"] = "*Please enter your doctor name.";
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  handleChange = (event) => {
    this.setState({ errors: "" });
    let fields = this.state.fields;
    fields[event.target.name] = event.target.value;
    this.setState(
      {
        fields,
      },
      () => this.validateForm()
    );
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  // Handle change in number of rows
  handleTableRowsChange = (event) => {
    const rows = parseInt(event.target.value, 10);
    this.setState({
      tableRows: rows,
      tableData: Array(rows)
        .fill("")
        .map(() => Array(this.state.tableColumns).fill("")),
    });
  };

  // Handle change in number of columns
  handleTableColumnsChange = (event) => {
    const columns = parseInt(event.target.value, 10);

    // Update the number of columns and adjust table data accordingly
    this.setState((prevState) => {
      // Handle the case where columns are being increased or decreased
      const newTableData = prevState.tableData.map((row) => {
        // If decreasing columns, slice off extra columns
        if (columns < row.length) {
          return row.slice(0, columns);
        }
        // If increasing columns, add empty cells to fill the new columns
        return [...row, ...Array(columns - row.length).fill("")];
      });

      return {
        tableColumns: columns,
        tableData: newTableData,
      };
    });
  };

  // Handle individual cell change
  handleTableCellChange = (e, rowIndex, colIndex) => {
    const newTableData = [...this.state.tableData];
    newTableData[rowIndex][colIndex] = e.target.value;
    this.setState({ tableData: newTableData });
  };

  // Generate HTML for the table
  // generateTableHTML() {
  //   let tableHTML = "<table class='table table-secondary table-striped table-hover'>";
  //   this.state.tableData.forEach((row) => {
  //     tableHTML += "<tr>";
  //     row.forEach((cell) => {
  //       tableHTML += `<td>${cell}</td>`;
  //     });
  //     tableHTML += "</tr>";
  //   });
  //   tableHTML += "</table>";
  //   return tableHTML;
  // }
  generateTableHTML() {
    let tableHTML =
      "<table class='table table-secondary table-striped table-hover'>";

    this.state.tableData.forEach((row, rowIndex) => {
      tableHTML += "<tr>";

      row.forEach((cell, colIndex) => {
        // Check if it's the first row (header row)
        if (rowIndex === 0) {
          // Use <th> for header cells to make the text bold
          tableHTML += `<th>${cell}</th>`;
        } else {
          // Use <td> for other rows (content cells)
          tableHTML += `<td>${cell}</td>`;
        }
      });

      tableHTML += "</tr>";
    });

    tableHTML += "</table>";
    return tableHTML;
  }

  // description logic here
  // Handle adding a new description field
  addDescription = () => {
    this.setState((prevState) => ({
      descriptions: [
        ...prevState.descriptions,
        { value: "", visibility: 1 }, // Add a new description with default visibility
      ],
    }));
  };

  // Handle removing a specific description field
  removeDescription = (index) => {
    this.setState((prevState) => {
      const updatedDescriptions = [...prevState.descriptions];
      updatedDescriptions.splice(index, 1); // Remove the description at the given index
      return { descriptions: updatedDescriptions };
    });
  };

  // Handle toggling visibility of a description
  toggleVisibility = (index) => {
    this.setState((prevState) => {
      const updatedDescriptions = [...prevState.descriptions];
      updatedDescriptions[index].visibility =
        updatedDescriptions[index].visibility === 1 ? 0 : 1;
      return { descriptions: updatedDescriptions };
    });
  };

  // Handle updating the value of a description field
  handleDescriptionChange = (index, value, key) => {
    this.setState((prevState) => {
      const updatedDescriptions = [...prevState.descriptions];
      updatedDescriptions[index].value = value;
      updatedDescriptions[index].key = key;
      return { descriptions: updatedDescriptions };
    });
  };
  generateRandomText(length = 16) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return result;
  }

  // multiple select search dropdown
  handleSelectionChange = (type, id) => {
    this.setState((prevState) => {
      const isSelected = prevState[type].includes(id);

      return {
        [type]: isSelected
          ? prevState[type].filter((item) => item !== id) // Remove if already selected
          : [...prevState[type], id], // Add if not selected
      };
    });
  };

  handleSearchChange = (searchField, value) => {
    this.setState({ [searchField]: value });
  };
  handleScheduleChange = (event) => {
    let Schedule = this.state.Schedule;
    Schedule[event.target.name] = event.target.value;
    this.setState({
      Schedule,
    });
  };

  // toggleStatus = (index) => {
  //   this.setState((prevState) => {
  //     const newStatusList = [...prevState.status_list];
  //     newStatusList[index].visibility =
  //       newStatusList[index].visibility === 1 ? 0 : 1;
  //     return { status_list: newStatusList };
  //   });
  // };
  onBlur(evt) {
    console.log("onBlur event called with event info: ", evt);
  }
  afterPaste(evt) {
    console.log("afterPaste event called with event info: ", evt);
  }
  onFileChange(file) {
    this.setState({
      doctor_profile: file[0],
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    if (this.validateForm() === true) {
      const tableHTML = this.generateTableHTML();
      const data = {
        doctor_name: this.state.doctor_name,
        doctor_degree: this.state.doctor_degree,
        designation: this.state.doctor_designation,
        doctor_fees: this.state.doctor_fees,
        doctor_department: this.state.doctor_department,
        doctor_uhl_id: this.state.doctor_uhl_id,
        doctor_bmdc_id: this.state.doctor_bmdc_id,
      };
      saveDoctor(
        data,
        this.state.doctor_profile,
        // this.state.status_list,
        this.state.Schedule,
        this.state.selectedDepartmentId,
        this.state.descriptions,
        {
          row: this.state.tableRows,
          column: this.state.tableColumns,
          tableHTML,
        } // Send table HTML as part of the data
      )
        .then((res) => {
          toast.success(res.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(function () {
            window.location.href = "/admin/doctors";
          }, 6000);
        })
        .catch((err) => {
          toast.error(err, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        });
    } else {
      toast.error("Please provide all required fields!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };
  refreshDepartments = (event) => {
    getAllDepartments()
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          this.setState({ departments: records });
        } else {
          this.setState({ departments: "" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  componentDidMount() {
    this.setState({ editorLoaded: true });
    this.refreshDepartments();
  }
  render() {
    const { departments, departmentSearch, selectedDepartmentId } = this.state;

    const filteredDepartments = departments.filter((department) =>
      department.department_name
        .toLowerCase()
        .includes(departmentSearch.toLowerCase())
    );
    return (
      <div className="fixed-left">
        <div id="wrapper">
          <Route component={LeftSidebar} />
          <div className="content-page">
            <div className="content">
              <Route component={TopHeader} />
              <div className="page-content-wrapper">
                <div className="col-lg-12">
                  <div className="card m-b-20">
                    <div className="card-body">
                      <h4 className="mt-0 header-title">Add Doctor</h4>
                      <form
                        onSubmit={this.handleSubmit}
                        id="editdoctorform"
                        className="needs-validation"
                        noValidate
                      >
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Doctor Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="doctor_name"
                                id="doctor_name"
                                value={this.state.doctor_name}
                                onChange={this.handleChange}
                                required
                                placeholder="Doctor Name"
                              />
                              <span style={alertStyle}>
                                {this.state.errors.doctor_name}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Doctor Degree</label>
                              <input
                                type="text"
                                className="form-control"
                                name="doctor_degree"
                                id="doctor_degree"
                                value={this.state.doctor_degree}
                                onChange={this.handleChange}
                                required
                                placeholder="Doctor Degree"
                              />
                              <span style={alertStyle}>
                                {this.state.errors.doctor_degree}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Doctor Designation</label>
                              <input
                                type="text"
                                className="form-control"
                                name="doctor_designation"
                                id="doctor_designation"
                                value={this.state.doctor_designation}
                                onChange={this.handleChange}
                                required
                                placeholder="Doctor Designation"
                              />
                              <span style={alertStyle}>
                                {this.state.errors.doctor_degree}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Doctor Department</label>
                              <input
                                type="text"
                                className="form-control mb-2"
                                placeholder="Search departments"
                                value={departmentSearch}
                                onChange={(e) =>
                                  this.handleSearchChange(
                                    "departmentSearch",
                                    e.target.value
                                  )
                                }
                              />
                              <div
                                style={{
                                  border: "1px solid #ced4da",
                                  borderRadius: "4px",
                                  padding: "10px",
                                  maxHeight: "200px",
                                  overflowY: "scroll",
                                }}
                              >
                                {filteredDepartments.length > 0 ? (
                                  filteredDepartments.map((department) => (
                                    <div
                                      key={department.id}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        value={department.dept_id}
                                        checked={selectedDepartmentId.includes(
                                          department.id
                                        )}
                                        onChange={() =>
                                          this.handleSelectionChange(
                                            "selectedDepartmentId",
                                            department.id
                                          )
                                        }
                                        style={{ marginRight: "10px" }}
                                      />
                                      <span>{department.department_name}</span>
                                    </div>
                                  ))
                                ) : (
                                  <p>No departments found</p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Doctor Fees</label>
                              <input
                                type="number"
                                className="form-control"
                                name="doctor_fees"
                                id="doctor_fees"
                                value={this.state.doctor_fees}
                                onChange={this.handleChange}
                                required
                                placeholder="Doctor Fees"
                              />
                              <span style={alertStyle}>
                                {this.state.errors.doctor_fees}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Doctor UHL Id:</label>
                              <input
                                type="text"
                                className="form-control"
                                name="doctor_uhl_id"
                                id="doctor_uhl_id"
                                value={this.state.doctor_uhl_id}
                                onChange={this.handleChange}
                                required
                                placeholder="Doctor UHL Id"
                              />
                              <span style={alertStyle}>
                                {this.state.errors.doctor_uhl_id}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Doctor BMDC Id</label>
                              <input
                                type="text"
                                className="form-control"
                                name="doctor_bmdc_id"
                                id="doctor_bmdc_id"
                                value={this.state.doctor_bmdc_id}
                                onChange={this.handleChange}
                                required
                                placeholder="Doctor BMDC Id"
                              />
                              <span style={alertStyle}>
                                {this.state.errors.doctor_bmdc_id}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div>
                          <h4>Add Department Descriptions</h4>
                          {this.state.descriptions.map((desc, index) => (
                            <div key={index} className="row mb-2">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>{`Description ${index + 1}`}</label>
                                  <NewReachTextEditor
                                    id={`Description-${index + 1}`}
                                    name={`Description-${index + 1}`}
                                    value={desc.value}
                                    onChange={(name, val) =>
                                      this.handleDescriptionChange(
                                        index,
                                        val,
                                        this.generateRandomText()
                                      )
                                    }
                                  />
                                  <div className="d-flex justify-content-between align-items-center">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        this.toggleVisibility(index)
                                      }
                                      className={`btn ${desc.visibility === 1
                                          ? "btn-success"
                                          : "btn-danger"
                                        } mt-2`}
                                    >
                                      {desc.visibility === 1 ? "Hide" : "Show"}
                                    </button>
                                    {index > 0 && (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          this.removeDescription(index)
                                        }
                                        className="btn btn-danger ml-2 mt-2"
                                      >
                                        Remove
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                          <button
                            type="button"
                            onClick={this.addDescription}
                            className="btn btn-primary mb-3"
                          >
                            Add Description
                          </button>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <h4>Table Content</h4>
                              {/* Table Rows Input */}
                              <div className="col-sm-4">
                                <div className="form-group">
                                  <label>Number of Rows</label>
                                  <input
                                    type="number"
                                    min="1"
                                    className="form-control"
                                    value={this.state.tableRows}
                                    onChange={this.handleTableRowsChange}
                                  />
                                </div>
                              </div>

                              {/* Table Columns Input */}
                              <div className="col-sm-4">
                                <div className="form-group">
                                  <label>Number of Columns</label>
                                  <input
                                    type="number"
                                    min="1"
                                    className="form-control"
                                    value={this.state.tableColumns}
                                    onChange={this.handleTableColumnsChange}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Table Content</label>
                                    <table border="1" className="table">
                                      <tbody>
                                        {this.state.tableData.map(
                                          (row, rowIndex) => (
                                            <tr key={rowIndex}>
                                              {row.map((cell, colIndex) => (
                                                <td key={colIndex}>
                                                  <input
                                                    type="text"
                                                    value={cell}
                                                    onChange={(e) =>
                                                      this.handleTableCellChange(
                                                        e,
                                                        rowIndex,
                                                        colIndex
                                                      )
                                                    }
                                                    placeholder="Enter text"
                                                  />
                                                </td>
                                              ))}
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Doctor Profile</label>
                              <input
                                type="file"
                                className="form-control"
                                name="doctor_profile"
                                id="doctor_profile"
                                onChange={(event) =>
                                  this.onFileChange(event.target.files)
                                }
                                accept="jpg,png"
                                placeholder="Doctor Fees"
                              />
                            </div>
                          </div>
                        </div>
                        <h4 className="mt-4 header-title">Doctor Schedule</h4>
                        <hr />
                        <div className="row">
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group d-flex justify-content-between">
                              <label>Saturday:</label>
                              <input
                                type="text"
                                placeholder="e.g., 09:00 AM - 08:00 PM"
                                className="form-control w-50"
                                name="Saturday"
                                value={this.state.Schedule.Saturday}
                                onChange={(e) => this.handleScheduleChange(e)}
                              />
                            </div>
                            <div className="form-group d-flex justify-content-between">
                              <label>Sunday:</label>
                              <input
                                type="text"
                                placeholder="e.g., 09:00 AM - 08:00 PM"
                                className="form-control w-50"
                                name="Sunday"
                                value={this.state.Schedule.Sunday}
                                onChange={(e) => this.handleScheduleChange(e)}
                              />
                            </div>
                            <div className="form-group d-flex justify-content-between">
                              <label>Monday:</label>
                              <input
                                type="text"
                                placeholder="e.g., 09:00 AM - 08:00 PM"
                                className="form-control w-50"
                                name="Monday"
                                value={this.state.Schedule.Monday}
                                onChange={(e) => this.handleScheduleChange(e)}
                              />
                            </div>
                            <div className="form-group d-flex justify-content-between">
                              <label>Tuesday:</label>
                              <input
                                type="text"
                                placeholder="e.g., 09:00 AM - 08:00 PM"
                                className="form-control w-50"
                                name="Tuesday"
                                value={this.state.Schedule.Tuesday}
                                onChange={(e) => this.handleScheduleChange(e)}
                              />
                            </div>
                            <div className="form-group d-flex justify-content-between">
                              <label>Wednesday:</label>
                              <input
                                type="text"
                                placeholder="e.g., 09:00 AM - 08:00 PM"
                                className="form-control w-50"
                                name="Wednesday"
                                value={this.state.Schedule.Wednesday}
                                onChange={(e) => this.handleScheduleChange(e)}
                              />
                            </div>
                            <div className="form-group d-flex justify-content-between">
                              <label>Thursday:</label>
                              <input
                                type="text"
                                placeholder="e.g., 09:00 AM - 08:00 PM"
                                className="form-control w-50"
                                name="Thursday"
                                value={this.state.Schedule.Thursday}
                                onChange={(e) => this.handleScheduleChange(e)}
                              />
                            </div>
                            <div className="form-group d-flex justify-content-between">
                              <label>Friday:</label>
                              <input
                                type="text"
                                placeholder="e.g., 09:00 AM - 08:00 PM"
                                className="form-control w-50"
                                name="Friday"
                                value={this.state.Schedule.Friday}
                                onChange={(e) => this.handleScheduleChange(e)}
                              />
                            </div>
                            <div className="form-group">
                              <div>
                                <button
                                  type="submit"
                                  className="btn btn-pink waves-effect waves-light"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    );
  }
}
export default adddoctor;



// WEBPACK FOOTER //
// ./src/component/admin/adddoctor.js